export const CALCULATION_MAPDATA_DISTANCE = 'MAP/CALCULATION_MAPDATA_DISTANCE';

export function calculationDistance(place) {
    return { type: CALCULATION_MAPDATA_DISTANCE , place }
}